// components/cnt-poezd/component
/* global DEBUG */

import template  from './component.jade'
import types     from './scss/types.scss'
import Store     from 'Store'
import parseTime from 'lib/filters/parseUnixTime'
import parseOrderLink from 'lib/filters/parseOrderLink'
import onClick   from 'lib/methods/onClick'
import style from './style.scss'

var name = 'cnt-poezd'
var url = '/api/CntPoezd'

const store = new Store(name);

export default {

    name: name,
    template: template({
        style: style
    }),
    props: ['table', 'title'],
    mixins: [parseTime, parseOrderLink, onClick],

    data: () => ({
        url: url,
        name: name,
        kod_zakaza: null,
    }),
    ready() {
        // if (!this.$get('kod_zakaza')) return
        this.$set('data', null)
        // this.$set('title')
        this.$set('data', {'name': this.$data.name})
        this.$set('data', store.$get(this))
    },
    methods: {

    },
    computed: {
        table() {
            return this.data.table
        },
    },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/cnt-poezd/component.js
 **/